import { DefaultCondition, PfeBaseCondition } from '../conditions.model';

export const PFE_AND = 'PFE_AND';

/**
 * "PFE_AND" condition.
 * Will return "true" if all the conditions that are under the `condition` are true.
 * @example
 *
 * ```json
 * {
 *   "type": "PFE_AND",
 *   "conditions": [
 *     {
 *       "type": "PFE_EXPRESSION",
 *       "expression": "{$.myFancyExpression}"
 *     },
 *     {
 *       "type": "MY_FANCY_TYPE"
 *     }
 *   ]
 * }
 * ```
 */
export interface PfeAndCondition<CONDITION = DefaultCondition> extends PfeBaseCondition {
  type: typeof PFE_AND;
  conditions: CONDITION[];
}
